import React, { useState, useEffect, refreshFunction } from 'react';
import { Container, BodyColuna, ThisCardItem, ThisGanntItem, ScrollGantt, ItemGanttHeader, ThisGanntCol } from './styles';
import { Label, Input, Select } from "~/componentes/CustomForm";
import api from "~/services/api";
import "./gantt.css";

import IconDataModoC from '~/assets/icones/icon-data-c.svg';
import IconDataModoE from '~/assets/icones/icon-data-e.svg';

function CustomBodyContent({
  data,
  previsaoInicio,
  setPrevisaoInicio,
  previsaoFinal,
  setPrevisaoFinal,
  tipoGantt,
  setTipoGantt,
  idCliente,
  setIdCliente,
  idEtapa,
  setIdEtapa,
  idAnalista,
  setIdAnalista
}) {
  const [gantt, setGantt] = useState({});
  const [heightColBody, setHeightColBody] = useState(21);
  const [clientes, setClientes] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [analistas, setAnalistas] = useState([]);

  const dataDe = previsaoInicio.getFullYear() + "-" + ((previsaoInicio.getMonth() + 1) > 9 ? (previsaoInicio.getMonth() + 1) : "0" + (previsaoInicio.getMonth() + 1)) + "-" + ((previsaoInicio.getDate() + 1) > 9 ? (previsaoInicio.getDate()) : "0" + (previsaoInicio.getDate()));
  const dataAte = previsaoFinal.getFullYear() + "-" + ((previsaoFinal.getMonth() + 1) > 9 ? (previsaoFinal.getMonth() + 1) : "0" + (previsaoFinal.getMonth() + 1)) + "-" + ((previsaoFinal.getDate() + 1) > 9 ? (previsaoFinal.getDate()) : "0" + (previsaoFinal.getDate()));

  useEffect(() => {
    let itemGantt = {
      left: {
        colunas: [
          { titulo: "Título", name: "titulo" },
        ],
      },
      dados: data?.dados,
      right: {
        colunas: data?.colunas,
      },
      header: data?.header,
    };

    setHeightColBody(itemGantt?.dados?.length * 3);
    setGantt(itemGantt);
  }, [data]);

  useEffect(() => {
    async function handleRequests() {
      api.get("/signed/empresa/gestorprojeto/gerencia/analistas", { params: { ativo: 1 } })
        .then(response => setAnalistas(response.data));

      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { tipo: 'PRJ' } })
        .then(response => setEtapas(response.data));
    }

    handleRequests();
  }, []);

  return (
    <Container>
      <div className='content-gantt'>
        <div className='header'>
          <div className='titulo'>
            <img src={require('~/assets/menus/ativo/menu-gantt.svg')} alt={"Gantt"} />
            <h4 className="title">Gantt</h4>
          </div>
          <div className='filtro'>
            <div className='item'>
              <Select
                isString
                list={{ list: clientes, value: "id", label: "nomeFantasia" }}
                name="idCliente"
                firstOption="Todos Clientes"
                defaultValue={idCliente}
                onChange={(e) => {
                  const v = e.currentTarget.value || null;
                  setIdCliente(v);
                }}
              />
            </div>
            <div className='item'>
              <Select
                isString
                list={{ list: analistas, value: "id", label: "nome" }}
                name="idAnalista"
                defaultValue={idAnalista}
                firstOption="Todos Analistas"
                onChange={(e) => {
                  const v = e.currentTarget.value || null;
                  setIdAnalista(v);
                }}
              />
            </div>
            <div className='item'>
              <Select
                isString
                list={{ list: etapas, value: "id", label: "titulo" }}
                name="idEtapa"
                defaultValue={idEtapa}
                firstOption="Todas Etapas"
                onChange={(e) => {
                  const v = e.currentTarget.value || null;
                  setIdEtapa(v);
                }}
              />
            </div>
            <div className='item'>
              <Input
                name="dataDe"
                type="date"
                defaultValue={dataDe}
                onChange={(e) => {
                  const v = e.currentTarget.value || "";
                  setPrevisaoInicio(new Date(v + " 03:00:00"));
                }}
              />
            </div>
            <div className='item'>
              <Input
                name="dataAte"
                type="date"
                defaultValue={dataAte}
                onChange={(e) => {
                  const v = e.currentTarget.value || "";
                  setPrevisaoFinal(new Date(v + " 03:00:00"));
                }}
              />
            </div>
            <div className='item'>
              <Select
                isString
                list={{ list: [{ id: "P", titulo: "Projeto" }, { id: "A", titulo: "Analista" }], value: "id", label: "titulo" }}
                name="tipoGantt"
                defaultValue={tipoGantt}
                onChange={(e) => {
                  const v = e.currentTarget.value || "P";
                  setTipoGantt(v);
                }}
              />
            </div>
          </div>
        </div>
        <div className='body'>
          <BodyColuna className='body-left' {...{ height: heightColBody + "em" }}>
            <div className='body-header'>
              <div className="info-cab">
                {gantt?.left?.colunas?.map((thisData, l) => (
                  <p className={thisData?.name}>{thisData?.titulo}</p>
                ))}
              </div>
            </div>
            <div className='body-content'>
              {gantt?.dados?.map((thisData, a) => (
                <ThisCardItem>
                  <div className={a % 2 === 0 ? 'item' : 'item light'}
                    onClick={() => {
                      let dados = [];
                      let count = 0;
                      for (const item of gantt?.dados) {
                        if (thisData?.id == item?.id) {
                          dados.push({ ...item, ativo: !item?.ativo });
                        } else {
                          dados.push({ ...item, ativo: item?.ativo });
                        }

                        if (dados[dados?.length - 1]?.ativo == true) {
                          count += 1 + dados[dados?.length - 1]?.itens?.length;
                        } else {
                          count += 1;
                        }
                      }

                      let itemGantt = {
                        left: gantt?.left,
                        dados,
                        right: gantt?.right,
                        header: gantt?.header,
                      };
                      setGantt(itemGantt);
                      setHeightColBody(count * 3);
                    }}
                  >
                    <div className="limite"></div>
                    <div className='item-colunas'>
                      <div className='row-coluna'>
                        <p>{thisData?.titulo?.length > 50 ? thisData?.titulo?.substr(0, 50) + "..." : thisData?.titulo}</p>
                      </div>
                      <div className='row-data'>
                        <div className='data-text'>
                          <img src={IconDataModoE} alt="IconDataModoE" />
                          <p>Inicio: {((new Date(thisData?.dataInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        </div>
                        <div className='data-text'>
                          <img src={IconDataModoE} alt="IconDataModoE" />
                          <p>Fim: {((new Date(thisData?.dataFim).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {thisData?.ativo && thisData?.itens?.map((thisItem, b) => (
                    <ThisCardItem>
                      <div className={'item subItem'}
                        onClick={() => {
                          let dados = [];
                          let count = 0;
                          for (const item of gantt?.dados) {
                            if (thisData?.id == item?.id) {
                              let itens = [];
                              for (const subItem of item?.itens) {
                                if (thisItem?.id == subItem?.id) {
                                  itens.push({ ...subItem, ativo: !subItem?.ativo });
                                } else {
                                  itens.push({ ...subItem, ativo: subItem?.ativo });
                                }
                              }

                              dados.push({ ...item, itens });
                            } else {
                              dados.push({ ...item, ativo: item?.ativo });
                            }
                          }


                          for (const item of dados) {
                            if (item?.ativo == true) {
                              for (const subItem of item?.itens) {
                                if (subItem?.ativo == true) {
                                  count += subItem?.itens?.length;
                                }

                                count += 1;
                              }
                            }

                            count += 1;
                          }

                          let itemGantt = {
                            left: gantt?.left,
                            dados,
                            right: gantt?.right,
                            header: gantt?.header,
                          };
                          setGantt(itemGantt);
                          setHeightColBody(count * 3);
                        }}
                      >
                        <div className="limite"></div>
                        <div className='item-colunas'>
                          <div className='row-coluna'>
                            <p>{thisItem?.titulo}</p>
                          </div>
                          <div className='row-data'>
                            <div className='data-text'>
                              <img src={IconDataModoE} alt="IconDataModoE" />
                              <p>Inicio: {((new Date(thisItem?.dataInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                            </div>
                            <div className='data-text'>
                              <img src={IconDataModoE} alt="IconDataModoE" />
                              <p>Fim: {((new Date(thisItem?.dataFim).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {thisItem?.ativo && thisItem?.itens?.map((thisItem2, c) => (
                        <ThisCardItem>
                          <div className={'item subSubItem'}>
                            <div className="limite"></div>
                            <div className='item-colunas'>
                              <div className='row-coluna'>
                                <p>{thisItem2?.titulo}</p>
                              </div>
                              <div className='row-data'>
                                <div className='data-text'>
                                  <img src={IconDataModoE} alt="IconDataModoE" />
                                  <p>Inicio: {((new Date(thisItem2?.dataInicio).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                                </div>
                                <div className='data-text'>
                                  <img src={IconDataModoE} alt="IconDataModoE" />
                                  <p>Fim: {((new Date(thisItem2?.dataFim).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ThisCardItem>
                      ))}
                    </ThisCardItem>
                  ))}
                </ThisCardItem>
              ))}
            </div>
          </BodyColuna>
          <BodyColuna className='body-right' {...{ height: heightColBody + "em" }}>
            <div className='body-header'>
              <div className="semanas fixed-semanas">
                {gantt?.header?.map((thiSem) => (
                  <ItemGanttHeader {...{ width: thiSem?.quant * 2 }}>
                    <p className="semana">{thiSem?.titulo}</p>
                  </ItemGanttHeader>
                ))}
              </div>
              <ThisGanntCol className='fixed-item'>
                <div className='item'>
                  {gantt?.right?.colunas?.map((thisData, i) => (
                    <div className="col col-dias">
                      <div className="card-dia">
                        <p className="dia">{thisData?.titulo}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </ThisGanntCol>
            </div>
            <div className='body-content'>
              <div className="content-right">
                <div className="grade">
                  <div className="section">
                    <div>
                      {gantt?.dados?.map((thisData, a) => (
                        <ThisGanntItem>
                          <div className={a % 2 === 0 ? 'item' : 'item light'}>
                            {gantt?.right?.colunas?.map((thisCol, b) => (
                              <div className='col'>
                                {thisCol?.value >= thisData?.diaInicial && thisCol?.value <= thisData?.diaFinal ?
                                  (
                                    <div className={'barra barra-1 ' + (thisCol?.value === thisData?.diaInicial ? 'inicio ' : '') + (thisCol?.value === thisData?.diaFinal ? 'final' : '')} />
                                  ) : (
                                    <div />
                                  )
                                }
                              </div>
                            ))}
                          </div>
                          {thisData?.ativo && thisData?.itens?.map((thisItem, b) => (
                            <ThisGanntItem>
                              <div className={'item subItem'}>
                                {gantt?.right?.colunas?.map((thisCol, b) => (
                                  <div className='col'>
                                    {thisCol?.value >= thisItem?.diaInicial && thisCol?.value <= thisItem?.diaFinal ?
                                      (
                                        <div className={'barra barra-2 ' + (thisCol?.value === thisItem?.diaInicial ? 'inicio ' : '') + (thisCol?.value === thisItem?.diaFinal ? 'final' : '')} />
                                      ) : (
                                        <div />
                                      )
                                    }
                                  </div>
                                ))}
                              </div>
                              {thisItem?.ativo && thisItem?.itens?.map((thisItem2, c) => (
                                <ThisGanntItem>
                                  <div className={'item subSubItem'}>
                                    {gantt?.right?.colunas?.map((thisCol, b) => (
                                      <div className='col'>
                                        {thisCol?.value >= thisItem2?.diaInicial && thisCol?.value <= thisItem2?.diaFinal ?
                                          (
                                            <div className={'barra barra-3 ' + (thisCol?.value === thisItem2?.diaInicial ? 'inicio ' : '') + (thisCol?.value === thisItem2?.diaFinal ? 'final' : '')} />
                                          ) : (
                                            <div />
                                          )
                                        }
                                      </div>
                                    ))}
                                  </div>
                                </ThisGanntItem>
                              ))}
                            </ThisGanntItem>
                          ))}
                        </ThisGanntItem>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BodyColuna>
        </div>
      </div>
    </Container>
  );
}

export default CustomBodyContent;

